import { setInitialState } from '../../../utils/reducerOperations';

export const Default = () => ({
    fetchDemographicsApi: setInitialState(),

});